import { Component, Input } from "@angular/core";

@Component({
  selector: "app-conflicto-sesion",
  templateUrl: "conflicto-sesion.component.html",
  styleUrls: ["conflicto-sesion.component.scss"]
})
export class ConflictoSesionComponent {
  /** Indica si se está procesando una acción (muestra el loading) */
  @Input() isLoading: boolean = false;

  /** Mensaje del loading */
  @Input() loadingMessage: string = "Cerrando sesión anterior...";

  /** Mensaje a mostrar al usuario */
  @Input() statusMessage: string = "Ya tiene una sesión activa en otro dispositivo.";

  /** Mensaje secundario descriptivo */
  @Input() secondaryMessage: string = "Cierre la sesión para continuar";

  /** Indica si hay un error (muestra alerta de advertencia) */
  @Input() isError: boolean = false;

  /** Muestra el bloque con el timer de sesión */
  @Input() showCloseSessionsButton: boolean = true;
}
